export default "__VITE_ASSET__CDnjFPu___"